import React, { useState, useEffect } from "react";
import { Tabs } from "flowbite-react";
import { HiUserCircle } from "react-icons/hi";
import { MdDashboard } from "react-icons/md";

const DataTable = ({ data, matchDetails , matches }) => {
  const [sortedData, setSortedData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: "total_damage", order: "desc" });
  const [expandedMatch, setExpandedMatch] = useState(null);

  const toggleMatch = (matchid) => {
    setExpandedMatch((prev) => (prev === matchid ? null : matchid));
  };

  useEffect(() => {
    if (data) {
      const sorted = [...data].sort((a, b) => b.total_damage - a.total_damage);
      setSortedData(sorted);
    }
  }, [data]);

  const handleSort = (key) => {
    const newOrder = sortConfig.order === "asc" ? "desc" : "asc";
    const sorted = [...sortedData].sort((a, b) => {
      if (a[key] < b[key]) return newOrder === "asc" ? -1 : 1;
      if (a[key] > b[key]) return newOrder === "asc" ? 1 : -1;
      return 0;
    });
    setSortedData(sorted);
    setSortConfig({ key, order: newOrder });
  };

  return (
    <Tabs aria-label="Default tabs" variant="default">

      <Tabs.Item active title="Player Ranking" icon={HiUserCircle}>
        <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
          <table className="w-full text-sm text-left text-gray-500">
            <thead className="text-xs text-gray-700 bg-gray-50">
              <tr>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("name")}
                >
                  Name {sortConfig.key === "name" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_damage")}
                >
                  Total Damage {sortConfig.key === "total_damage" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_kills")}
                >
                  Total Kills {sortConfig.key === "total_kills" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_assists")}
                >
                  Total Assists {sortConfig.key === "total_assists" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_deaths")}
                >
                  Total Deaths {sortConfig.key === "total_deaths" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("winrate")}
                >
                  Win rate {sortConfig.key === "winrate" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_utility_damage")}
                >
                  Utility damage {sortConfig.key === "total_utility_damage" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_head_shot_kills")}
                >
                  Headshots {sortConfig.key === "total_head_shot_kills" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_entry_wins")}
                >
                  Entry wins {sortConfig.key === "total_entry_wins" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
                <th
                  scope="col"
                  className="px-6 py-3 cursor-pointer"
                  onClick={() => handleSort("total_enemies_flashed")}
                >
                  Enemis flashed {sortConfig.key === "total_enemies_flashed" ? (sortConfig.order === "asc" ? "▲" : "▼") : ""}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData && sortedData.length > 0 ? sortedData.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                  <td className="px-6 py-4">{item.name}</td>
                  <td className="px-6 py-4">{item.total_damage}</td>
                  <td className="px-6 py-4">{item.total_kills}</td>
                  <td className="px-6 py-4">{item.total_assists}</td>
                  <td className="px-6 py-4">{item.total_deaths}</td>
                  <td className="px-6 py-4">{item.winrate}</td>
                  <td className="px-6 py-4">{item.total_utility_damage}</td>
                  <td className="px-6 py-4">{item.total_head_shot_kills}</td>
                  <td className="px-6 py-4">{item.total_entry_wins}</td>
                  <td className="px-6 py-4">{item.total_enemies_flashed}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="10" className="px-6 py-4 text-center text-gray-500">
                    No player statistics available. Database connection required.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Tabs.Item>

      <Tabs.Item title="Matches" icon={MdDashboard}>
      <div className="overflow-x-auto relative shadow-md sm:rounded-lg">
        <table className="table-auto w-full text-sm text-left text-gray-500">
          <thead className="text-xs text-gray-700  bg-gray-50">
            <tr>
              <th scope="col" className="px-6 py-3">Start</th>
              <th scope="col" className="px-6 py-3">Map</th>
              <th scope="col" className="px-6 py-3">Match</th>
              <th scope="col" className="px-6 py-3">Result</th>
            </tr>
          </thead>
          <tbody>
            {matches && matches.length > 0 ? matches.map((match) => {
              const details = matchDetails[match.matchid];
              const team1Name = details?.team1?.[0]?.team_name || "Team 1";
              const team2Name = details?.team2?.[0]?.team_name || "Team 2";
              const isExpanded = expandedMatch === match.matchid;

              return (
                <React.Fragment key={match.matchid}>
                  {/* Hauptzeile */}
                  <tr
                    onClick={() => toggleMatch(match.matchid)}
                    className={`bg-white border-b cursor-pointer ${
                      isExpanded ? "bg-gray-100" : ""
                    }`}
                  >
                    <td className="px-6 py-4">
                      {new Date(match.start_time).toLocaleString()}
                    </td>
                    <td className="px-6 py-4">{match.mapname}</td>
                    <td className="px-6 py-4">
                      {match.winner === team1Name ? (
                        <>
                          <strong className="font-bold">{team1Name}</strong> vs {team2Name}
                        </>
                      ) : (
                        <>
                          {team1Name} vs{" "}
                          <strong className="font-bold">{team2Name}</strong>
                        </>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      {match.team1_score}:{match.team2_score}
                    </td>
                  </tr>

                  {/* Expandierte Zeile */}
                  {isExpanded && (
                    <tr>
                      <td colSpan="4" className="px-6 py-4 bg-gray-50">
                        <div className="mb-4">
                          <h4 className="font-bold text-gray-700">{team1Name}</h4>
                          <table className="w-full text-sm">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Damage</th>
                                <th>Kills</th>
                                <th>Assists</th>
                                <th>Deaths</th>
                                <th>Utility Damage</th>
                              </tr>
                            </thead>
                            <tbody>
                              {details.team1
                                .slice()
                                .sort((a, b) => b.damage - a.damage)
                                .map((player, index) => (
                                  <tr key={index}>
                                    <td>{player.name}</td>
                                    <td>{player.damage}</td>
                                    <td>{player.kills}</td>
                                    <td>{player.assists}</td>
                                    <td>{player.deaths}</td>
                                    <td>{player.utility_damage}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                        <div>
                          <h4 className="font-bold text-gray-700">{team2Name}</h4>
                          <table className="w-full text-sm">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Damage</th>
                                <th>Kills</th>
                                <th>Assists</th>
                                <th>Deaths</th>
                                <th>Utility Damage</th>
                              </tr>
                            </thead>
                            <tbody>
                              {details.team2
                                .slice()
                                .sort((a, b) => b.damage - a.damage)
                                .map((player, index) => (
                                  <tr key={index}>
                                    <td>{player.name}</td>
                                    <td>{player.damage}</td>
                                    <td>{player.kills}</td>
                                    <td>{player.assists}</td>
                                    <td>{player.deaths}</td>
                                    <td>{player.utility_damage}</td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              );
            }) : (
              <tr>
                <td colSpan="4" className="px-6 py-4 text-center text-gray-500">
                  No match data available. Database connection required.
                </td>
              </tr>
            )}
          </tbody>
        </table>
        </div>
      </Tabs.Item>

    </Tabs>
  );
};

export default DataTable;